module.exports = __webpack_public_path__ + "img/newsletter_careers.e5e46826.png";